import { render, staticRenderFns } from "./ErrorWidget.vue?vue&type=template&id=2ba85628&scoped=true&"
import script from "./ErrorWidget.vue?vue&type=script&lang=js&"
export * from "./ErrorWidget.vue?vue&type=script&lang=js&"
import style0 from "./ErrorWidget.vue?vue&type=style&index=0&id=2ba85628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba85628",
  null
  
)

export default component.exports